import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
  ListSuperadminRecordingAnalyticsRequest,
  ListSuperadminRecordingAnalyticsResponse,
  listSuperadminRecordingAnalyticsContract
} from '@bliks-io/contracts';
import { apiClient } from '@/api/client';
import { recordingAnalyticsKeys } from '@/api/query-keys';

export type RecordingAnalyticsFilters = ListSuperadminRecordingAnalyticsRequest;

export function useSuperAdminRecordingAnalytics(filters: RecordingAnalyticsFilters = {}) {
  return useQuery({
    queryKey: recordingAnalyticsKeys.list(filters),
    queryFn: async ({ signal }): Promise<ListSuperadminRecordingAnalyticsResponse> => {
      const { data } = await apiClient.get<ListSuperadminRecordingAnalyticsResponse>(
        listSuperadminRecordingAnalyticsContract.path,
        { params: filters, signal }
      );
      return data;
    },
    placeholderData: keepPreviousData
  });
}
